import { Permissions } from '@/shared/helpers/permissions'
import { useUserPermission } from '@/ui/hooks/useUserPermission'

import ToNotFound from '../ToNotFound'

export default function UserPermissionShowComponent({
  children,
  permission
}: {
  children: React.ReactNode
  permission: Permissions
}) {
  const { checkPermission } = useUserPermission()

  return (
    <ToNotFound shouldFindRoute={checkPermission(permission)}>
      {children}
    </ToNotFound>
  )
}
